'use client';
import { createContext } from '@chakra-ui/utils/context';
import { createDescendantContext } from '../descendant/use-descendant.mjs';

const [
  PinInputDescendantsProvider,
  usePinInputDescendantsContext,
  usePinInputDescendants,
  usePinInputDescendant
] = createDescendantContext();
const [PinInputProvider, usePinInputContext] = createContext({
  name: "PinInputContext",
  errorMessage: "usePinInputContext: `context` is undefined. Seems you forgot to place all pin input fields within `<PinInput />`"
});
const [PinInputStylesProvider, usePinInputStyles] = createContext({
  name: "PinInputStylesContext",
  errorMessage: "usePinInputStyles: `context` is undefined. Seems you forgot to place all pin input fields within `<PinInput />`"
});

export { PinInputDescendantsProvider, PinInputProvider, PinInputStylesProvider, usePinInputContext, usePinInputDescendant, usePinInputDescendants, usePinInputDescendantsContext, usePinInputStyles };
